// primitives/field/FieldHelper.tsx
import * as React from "react";

export function FieldHelper(props: React.HTMLAttributes<HTMLDivElement>) {
  return <div {...props} data-field-helper />;
}
